import React, { useState, useEffect, useRef } from 'react';

const PatentedSection = ({ t }) => {
  const statsRef = useRef(null);
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const currentRef = statsRef.current;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setStatsVisible(true);
          }
        });
      },
      { threshold: 0.15 }
    );
    
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, []);

  // Split stats into lines
  const statsLines = t.patentedDesc ? t.patentedDesc.split('\n') : [];

  return (
    <section id="patented" className="patented-section" aria-labelledby="patented-title">
      <div 
        className="patented-background"
        style={{ backgroundImage: `url(https://customer-assets.emergentagent.com/job_bc2024cc-e7d8-4e56-881a-2fc8b92402e9/artifacts/j40nln5j_night1.jpg)` }}
      >
        <div className="patented-overlay"></div>
        <div className="patented-text-band">
          <div ref={statsRef} className="patented-text-content">
            <h2 id="patented-title" className="patented-title">
              {t.patentedTitle}
            </h2>
            <div className="patented-stats-list" role="list">
              {statsLines.map((line, i) => (
                <p 
                  key={`stat-line-${i}`} 
                  className={`patented-stat-item ${statsVisible ? 'visible' : ''}`} 
                  style={{ transitionDelay: `${i * 80}ms` }}
                  role="listitem"
                >
                  {line}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(PatentedSection);
